'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global services*/
/*global isEmpty*/
/*global initialize*/
/*global createObjectCallBack*/

function ProjectJobQueue() {

  this.init();
}

ProjectJobQueue.prototype = $.extend({}, {
  constructor: 'ProjectJobQueue',

  registerCallbacks: function () {
    var _this = this;

    $('body').on('click', '.project-job-queue-confirm', function () {
      _this.showConfirmForm($(this).data('job_queue_rid'), $(this).data('callback'));
      return false;
    });

    $('body').on('click', '.project-job-queue-confirm--copy-invoice-text', function () {
      _this.copyInvoiceText($(this).data('invoice_text'));
      return false;
    });

    $('body').on('click', '.project-job-queue-unconfirm-and-timesheet', function () {
      _this.unconfirmAndTimesheet($(this), $(this).data('job_queue_rid'), $(this).data('callback'));
      return false;
    });

    $('body').on('click', '.project-job-queue-unconfirm-and-stopwatch', function () {
      _this.unconfirmAndStopwatch($(this), $(this).data('job_queue_rid'), $(this).data('project_title'), $(this).data('task_title'));
      return false;
    });

    $('body').on('click', '.project-stage-planned-operation-resource-change-status', function () {
      _this.changeStatus($(this), $(this).data('rid'), $(this).data('to_status'), $(this).data('is_simple'));
      return false;
    });
  },

  //----------------------------------------------------------------------------

  copyInvoiceText: function copyInvoiceText(invoiceText) {
    var _this = this;

    var modal = services.get('modal');
    var $input = modal.contentDOM().find('[name$="[Description]"]');
    var text = $input.val();
    text = text + invoiceText;

    $input.val(text);

    return _this;
  },

  changeStatus: function changeStatus($btn, jobQueueRID, toStatus, isSimple) {
    var _this = this;

    blockElement($btn);
    $.get(services.get('router').path('project_job_queue_change_status', { jobQueueRID: jobQueueRID, toStatus: toStatus, isSimple: isSimple }), function (res) {
      unBlockElement($btn);
      if (res.msg === 'SUCCESS') {
        $btn.data('to_status', res.data.to_status);
        $btn.html(res.data.html);
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  showConfirmForm: function (jobQueueRID, callBack) {
    var _this = this;

    var modal = services.get('modal');
    modal.empty().open({
      title: services.get('translator').trans('project_job_queue.confirm'),
      saveBtnTitle: services.get('translator').trans('project_job_queue.do_confirm'),
      height: 'auto',
      minHeight: '300px',
      submitCallBack: createObjectCallBack(_this, 'submitForm', { callBack: callBack }),
      width: 'lg',
      form: true,
      keyboardClose: false
    });

    modal.block();
    $.get(services.get('router').path('project_job_queue_confirm', { jobQueueRID: jobQueueRID }), function (res) {
      modal.unBlock();
      if (res.msg === 'SUCCESS') {
        modal.content(res.data.html);
        _this.initForm();
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  initForm: function initForm() {
    var _this = this;

    var modal = services.get('modal');
    initialize(modal.contentDOM());

    $('#project_job_queue_confirm_Ex_Distance_check, #project_job_queue_confirm_Ex_Time_check').on('change', function () {
      var $this = $(this);

      $('#' + $this.prop('id').replace('_check', '')).prop('disabled', !$this.prop('checked'));
    });

    return _this;
  },

  doSubmitForm: function (params, confirmOtherResources) {
    var _this = this;

    var modal = services.get('modal');
    var $content = modal.contentDOM();
    var $form = $content.find('form');

    $.post($form.attr('action'), $form.serialize() + '&confirm_other_resources=' + (confirmOtherResources ? 1 : 0), function (res) {
      modal.unBlock();

      if (res.msg === 'SUCCESS') {
        modal.close();
        services.get('notifications').viewSaveMessage();

        if (('callBack' in params) && !isEmpty(params.callBack) && (params.callBack in window)) {
          window[params.callBack]();
        } else {
          if (services.has('dashboard')) {
            services.get('dashboard').invalidWidgetsByTag('timesheets');
            services.get('dashboard').invalidWidgetsByTag('job_queue');
          }
        }
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  confirmOtherResourcesForm: function (params) {
    var _this = this;

    var confirm = services.get('confirm');
    confirm.close();
    _this.doSubmitForm(params, true);
  },

  rejectOtherResourcesForm: function (params) {
    var _this = this;

    var confirm = services.get('confirm');
    confirm.close();
    _this.doSubmitForm(params, false);
  },

  submitForm: function (params) {
    var _this = this;

    var modal = services.get('modal');
    var $content = modal.contentDOM();
    var $form = $content.find('form');

    modal.block();
    $.post(services.get('router').path('project_job_queue_check_resources'), $form.serialize(), function (res) {
      //nejdrive zjistime, zdali ma vice zdroju, a zdali je nutne potvrzeni od uzivatel
      if (res.msg === 'SUCCESS') {
        if (res.data.view_confirm_question) {
          var confirm = services.get('confirm');
          confirm.empty().open({
            title: services.get('translator').trans('project_job_queue.confirm'),
            saveBtnTitle: services.get('translator').trans('project_job_queue.do_confirm'),
            confirmBtnTitle:  services.get('translator').trans('project_job_queue.confirm_other_resources'),
            rejectBtnTitle:  services.get('translator').trans('project_job_queue.not_confirm_other_resources'),
            confirmCallBack: createObjectCallBack(_this, 'confirmOtherResourcesForm', params),
            rejectCallBack: createObjectCallBack(_this, 'rejectOtherResourcesForm', params),
            content: res.data.html,
            width: 'md'
          });
        } else {
          _this.doSubmitForm(params, true);
        }
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  unconfirmAndStopwatch: function ($wrapper, jobQueueRID, projectTitle, taskTitle) {
    var _this = this;

    blockElement($wrapper);
    $.get(services.get('router').path('project_job_queue_unconfirm', { jobQueueRID: jobQueueRID }), function (res) {
      unBlockElement($wrapper);

      if (res.msg === 'SUCCESS') {
        if (services.has('dashboard')) {
          services.get('dashboard').invalidWidgetsByTag('timesheets');
          services.get('dashboard').invalidWidgetsByTag('job_queue');
        }

        if (services.has('stopwatches')) {
          services.get('stopwatches').addStopwatch(jobQueueRID, projectTitle, taskTitle);
        }
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  unconfirmAndTimesheet: function ($wrapper, jobQueueRID, callBack) {
    var _this = this;

    blockElement($wrapper);
    $.get(services.get('router').path('project_job_queue_unconfirm', { jobQueueRID: jobQueueRID }), function (res) {
      unBlockElement($wrapper);

      if (res.msg === 'SUCCESS') {
        if (services.has('dashboard')) {
          services.get('dashboard').invalidWidgetsByTag('timesheets');
          services.get('dashboard').invalidWidgetsByTag('job_queue');
        }

        if (services.has('project-timesheet')) {
          services.get('project-timesheet').showEditForm(null, null, null, jobQueueRID, null, null, callBack);
        }
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  init: function () {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
